import { axiosRequest } from '@planbord/axios-request';
import { useQuery } from '@tanstack/vue-query';
import {SelectOption} from "@planbord/shared/models";

export const useListShiftsSelectOptions = () => {
    const baseUrl = '/api';

    return useQuery<SelectOption[]>({
        queryKey: ['listShiftsSelectOptions'],
        queryFn: () =>
            axiosRequest
                .get(`${baseUrl}/listShiftsSelectOptions`)
                .then((res) => res.data),
        // Use the cache for 60 minutes
        staleTime: 60 * 60000,
    });
};
